const defaultTheme = require("tailwindcss/defaultTheme")
const { colors } = require("./colors.cjs")
const colorTokens = require("./tokens/colors.json")
const { getRootElColorCustomProperties } = require("./utils/getRootElColorCustomProperties.cjs")
const { screens } = require("./screens.cjs")
const { minWidth } = require("./minWidth.cjs")
const { maxWidth } = require("./maxWidth.cjs")
const { letterSpacing } = require("./letterSpacing.cjs")
const { lineHeight } = require("./lineHeight.cjs")
const { borderRadius } = require("./borderRadius.cjs")
const { fontWeight } = require("./fontWeight.cjs")
const { minHeight } = require("./minHeight.cjs")
const { backgroundImage } = require("./backgroundImage.cjs")
const { boxShadow } = require("./boxShadow.cjs")
const { width } = require("./width.cjs")
const { gridTemplateColumns } = require("./gridTemplateColumns.cjs")
const { gridTemplateRows } = require("./gridTemplateRows.cjs")
const { fontSize } = require("./fontSize.cjs")
const { spacing } = require("./spacing.cjs")
const { opacity } = require("./opacity.cjs")
const plugin = require("tailwindcss/plugin")

const theme = {
  colors,
  fontFamily: {
    mono: [...defaultTheme.fontFamily.mono],
    freigeist: [
      "Rene bieder freigeist xwide", // installed via partnerfleet.css
      "Work Sans",
      ...defaultTheme.fontFamily.sans,
    ],
    body: [
      "Work Sans", // This relies on the presence of Google fonts on the page. See `google-fonts.html.erb`, for example
      ...defaultTheme.fontFamily.sans,
    ],
    // Tailwind applies the sans font family to the html tag
    sans: [
      "Work Sans", // This relies on the presence of Google fonts on the page. See `google-fonts.html.erb`, for example
      ...defaultTheme.fontFamily.sans,
    ],
  },
  letterSpacing,
  lineHeight,
  maxWidth,
  minWidth,
  screens,
  extend: {
    backgroundImage,
    borderRadius,
    boxShadow,
    fontSize,
    fontWeight,
    gridTemplateColumns,
    gridTemplateRows,
    minHeight,
    opacity,
    spacing,
    width,
  },
}

const twindPlugin = () =>
  plugin(
    function ({ addBase }) {
      const baseStyles = {
        [":root"]: getRootElColorCustomProperties(colorTokens.color),
      }
      addBase(baseStyles)
    },
    { theme },
  )

module.exports = {
  twindPlugin,
  theme,
}
